import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import Pagination from 'react-js-pagination'
import PresetActions from '../../Redux/PresetRedux'
import CouponActions from '../../Redux/CouponRedux'
import ViewAffiliateHistory from '../../Containers/Coupon/ViewAffiliateHistory'
import FormatMoney from '../../Utils/FormatMoney'
import AdvancedFilter from '../../Components/AdvancedFilter'

class Affiliate extends React.Component {
  constructor (props) {
    super(props)
    this.filters = [
      {
        type: 'text',
        name: 'User Name',
        placeholder: 'User Name',
        field: 'name'
      },
      {
        type: 'selector',
        name: 'Status',
        placeholder: 'Status',
        field: 'status',
        selectors: [
          { label: 'All', value: '' },
          { label: 'Transfer Request', value: 'process' },
          { label: 'No Request', value: 'non-process' }
        ]
      }
    ]
    this.productType = [
      { label: 'All', value: 'all' },
      { label: 'E-Commerce', value: 'inventory' },
      { label: 'Attraction', value: 'attraction' },
      { label: 'Wifi Product', value: 'modem' },
      { label: 'Insurance', value: 'insurance' }
    ]
    this.state = {
      tab: 'affiliates-list',
      page: 1,
      filter: {
        page: 1
      },
      showModal: null,
      editMode: null,
      forceEditMode: false,
      detail: {},
      form: {
        general_affiliate_pisces_point: 0,
        general_affiliate_pisces_recharger: 0,
        general_affiliate_pisces_min_amount: 0,
        general_affiliate_pisces_discount_type: '',
        general_affiliate_pisces_discount_value: 0,
        general_affiliate_pisces_product_type: '' // 'inventory', 'attraction', 'modem', 'all', 'insurance'
      }
    }
    this.discountType = [
      { label: 'Price Cut', value: 'PRICE_CUT' },
      { label: 'Percentage Cut', value: 'PERCENTAGE_CUT' }
    ]
  }

  componentDidMount = () => {
    this.props.getAffiliates()
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.dataPresetOrder !== prevProps.dataPresetOrder) {
      this.props.getPreset()
    }
  }

  _selectItem = (modalID, item) => {
    this.setState({ detail: item })
    this._toggleModal(modalID)
  }

  _inputChange = (event, field) => {
    const value = event.target.value
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _changeTab = (args) => {
    this.setState({ tab: args })
  }

  _changePage = (page) => {
    let filter = { ...this.state.filter, page }
    this.setState({ filter })
    this._customFetch({ page })
  }

  _customFetch = (filter, event) => {
    if (event) event.preventDefault()
    let params = {
      ...this.state.filter,
      ...filter
    }
    this.props.getAffiliates(params)
  }

  _toggleModal = (modalID = null) => {
    this.setState({ showModal: modalID })
    if (!modalID) { this._customFetch() }
  }

  _editMode = (editModeID = null, field) => {
    const { preset } = this.props
    if (editModeID !== null) {
      let form = { ...this.state.form }
      form[field] = preset.dataPresetOrder[field]
      this.setState({ form })
    }
    this.setState({
      editMode: editModeID,
      forceEditMode: !this.state.forceEditMode
    })
  }

  _submit = (field, value) => {
    let data = { [field]: value }
    this.props.putPreset(data)
    setTimeout(() => {
      this._editMode()
    }, 500)
  }

  _convertLabel = (label) => {
    switch (label) {
      case 'all':
        return 'All'
      case 'inventory':
        return 'E-Commerce'
      case 'attraction':
        return 'Attraction'
      case 'modem':
        return 'Wifi Product'
      case 'insurance':
        return 'Insurance'
      default:
        return null
    }
  }

  _renderAffiliatePreset = (preset) => {
    return (
      <section className='section'>
        <div className='card'>
          <div className='card-block'>
            <table className='table table-hover table-striped'>
              <thead>
                <tr>
                  <th className='text-center'>Preset Name</th>
                  <th className='text-center'>Preset Value</th>
                  <th className='text-center'>Edit</th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td className='text-center'>Points earned per sobat</td>
                  <td className='text-center' style={{ maxWidth: '100px' }}>
                    {
                      this.state.editMode === 'pisces_point'
                        ? <div className='input-group'>
                          <input type='number' className='form-control my-0' value={this.state.form.general_affiliate_pisces_point} onChange={(event) => this._inputChange(event, 'general_affiliate_pisces_point')} />
                          <div className='input-group-append'>
                            <button className='btn btn-primary mb-0' onClick={() => this._submit('general_affiliate_pisces_point', this.state.form.general_affiliate_pisces_point)}>Submit</button>
                          </div>
                        </div>
                        : preset.dataPresetOrder.general_affiliate_pisces_point || 'Loading ...'
                    }
                  </td>
                  <td>
                    {
                      this.state.editMode === 'pisces_point'
                        ? <div className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._editMode()}><i className='fa fa-times-circle' /></button>
                        </div>
                        : <div className='text-center'>
                          <button disabled={this.state.forceEditMode} className='btn btn-primary' onClick={() => this._editMode('pisces_point', 'general_affiliate_pisces_point')}><i className='fa fa-edit' /></button>
                        </div>
                    }
                  </td>
                </tr>

                <tr>
                  <td className='text-center'>Minimum sobat amount to redeem</td>
                  <td className='text-center' style={{ maxWidth: '100px' }}>
                    {
                      this.state.editMode === 'pisces_recharger'
                        ? <div className='input-group'>
                          <input type='number' className='form-control my-0' value={this.state.form.general_affiliate_pisces_recharger} onChange={(event) => this._inputChange(event, 'general_affiliate_pisces_recharger')} />
                          <div className='input-group-append'>
                            <button className='btn btn-primary mb-0' onClick={() => this._submit('general_affiliate_pisces_recharger', this.state.form.general_affiliate_pisces_recharger)}>Submit</button>
                          </div>
                        </div>
                        : preset.dataPresetOrder.general_affiliate_pisces_recharger || 'Loading ...'
                    }
                  </td>
                  <td className='text-center'>
                    {
                      this.state.editMode === 'pisces_recharger'
                        ? <div className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._editMode()}><i className='fa fa-times-circle' /></button>
                        </div>
                        : <div className='text-center'>
                          <button disabled={this.state.forceEditMode} className='btn btn-primary' onClick={() => this._editMode('pisces_recharger', 'general_affiliate_pisces_recharger')}><i className='fa fa-edit' /></button>
                        </div>
                    }
                  </td>
                </tr>

                <tr>
                  <td className='text-center'>Minimum transaction amount to redeem</td>
                  <td className='text-center' style={{ maxWidth: '100px' }}>
                    {
                      this.state.editMode === 'pisces_min_amount'
                        ? <div className='input-group'>
                          <input type='number' className='form-control my-0' value={this.state.form.general_affiliate_pisces_min_amount} onChange={(event) => this._inputChange(event, 'general_affiliate_pisces_min_amount')} />
                          <div className='input-group-append'>
                            <button className='btn btn-primary mb-0' onClick={() => this._submit('general_affiliate_pisces_min_amount', this.state.form.general_affiliate_pisces_min_amount)}>Submit</button>
                          </div>
                        </div>
                        : FormatMoney(preset.dataPresetOrder.general_affiliate_pisces_min_amount) || 'Loading ...'
                    }
                  </td>
                  <td className='text-center'>
                    {
                      this.state.editMode === 'pisces_min_amount'
                        ? <div className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._editMode()}><i className='fa fa-times-circle' /></button>
                        </div>
                        : <div className='text-center'>
                          <button disabled={this.state.forceEditMode} className='btn btn-primary' onClick={() => this._editMode('pisces_min_amount', 'general_affiliate_pisces_min_amount')}><i className='fa fa-edit' /></button>
                        </div>
                    }
                  </td>
                </tr>

                <tr>
                  <td className='text-center'>Discount Type</td>
                  <td className='text-center' style={{ maxWidth: '100px' }}>
                    {
                      this.state.editMode === 'pisces_discount_type'
                        ? <div className='input-group'>
                          <select value={this.state.form.general_affiliate_pisces_discount_type} className='form-control my-0' onChange={(event) => this._inputChange(event, 'general_affiliate_pisces_discount_type', this.state.form.general_affiliate_pisces_discount_type)}>
                            <option disabled value=''>Discount Type</option>
                            {
                              this.discountType.map((item, i) => (
                                <option key={i} value={item.value}>{item.label}</option>
                              ))
                            }
                          </select>
                          <div className='input-group-append'>
                            <button className='btn btn-primary mb-0' onClick={() => this._submit('general_affiliate_pisces_discount_type', this.state.form.general_affiliate_pisces_discount_type)}>Submit</button>
                          </div>
                        </div>
                        : preset.dataPresetOrder.general_affiliate_pisces_discount_type === 'PRICE_CUT'
                          ? 'Price Cut'
                          : preset.dataPresetOrder.general_affiliate_pisces_discount_type === 'PERCENTAGE_CUT'
                            ? 'Percentage Cut'
                            : 'Loading ...'
                    }
                  </td>
                  <td className='text-center'>
                    {
                      this.state.editMode === 'pisces_discount_type'
                        ? <div className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._editMode()}>
                            <i className='fa fa-times-circle' />
                          </button>
                        </div>
                        : <div className='text-center'>
                          <button disabled={this.state.forceEditMode} className='btn btn-primary' onClick={() => this._editMode('pisces_discount_type', 'general_affiliate_pisces_discount_type')}>
                            <i className='fa fa-edit' />
                          </button>
                        </div>
                    }
                  </td>
                </tr>

                <tr>
                  <td className='text-center'>Discount Amount</td>
                  <td className='text-center' style={{ maxWidth: '100px' }}>
                    {
                      this.state.editMode === 'pisces_discount_value'
                        ? <div className='input-group'>
                          <input type='number' className='form-control my-0' value={this.state.form.general_affiliate_pisces_discount_value} onChange={(event) => this._inputChange(event, 'general_affiliate_pisces_discount_value')} />
                          <div className='input-group-append'>
                            <button className='btn btn-primary mb-0' onClick={() => this._submit('general_affiliate_pisces_discount_value', this.state.form.general_affiliate_pisces_discount_value)}>Submit</button>
                          </div>
                        </div>
                        : FormatMoney(preset.dataPresetOrder.general_affiliate_pisces_discount_value) || 'Loading ...'
                    }
                  </td>
                  <td>
                    {
                      this.state.editMode === 'pisces_discount_value'
                        ? <div className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._editMode()}><i className='fa fa-times-circle' /></button>
                        </div>
                        : <div className='text-center'>
                          <button disabled={this.state.forceEditMode} className='btn btn-primary' onClick={() => this._editMode('pisces_discount_value', 'general_affiliate_pisces_discount_value')}><i className='fa fa-edit' /></button>
                        </div>
                    }
                  </td>
                </tr>

                <tr>
                  <td className='text-center'>Discount Product Type</td>
                  <td className='text-center' style={{ maxWidth: '100px' }}>
                    {
                      this.state.editMode === 'pisces_product_type'
                        ? <div className='input-group'>
                          <select className='form-control' value={this.state.form.general_affiliate_pisces_product_type} onChange={(event) => this._inputChange(event, 'general_affiliate_pisces_product_type')}>
                            {
                              this.productType.map((option, i) => (
                                <option key={i} value={option.value}>{option.label}</option>
                              ))
                            }
                          </select>
                          <div className='input-group-append'>
                            <button className='btn btn-primary mb-0' onClick={() => this._submit('general_affiliate_pisces_product_type', this.state.form.general_affiliate_pisces_product_type)}>Submit</button>
                          </div>
                        </div>
                        : this._convertLabel(preset.dataPresetOrder.general_affiliate_pisces_product_type) || 'Loading ...'
                    }
                  </td>
                  <td>
                    {
                      this.state.editMode === 'pisces_product_type'
                        ? <div className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._editMode()}><i className='fa fa-times-circle' /></button>
                        </div>
                        : <div className='text-center'>
                          <button disabled={this.state.forceEditMode} className='btn btn-primary' onClick={() => this._editMode('pisces_product_type', 'general_affiliate_pisces_product_type')}><i className='fa fa-edit' /></button>
                        </div>
                    }
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </section>
    )
  }

  _renderAffiliateData = (data) => {
    if (!data) {
      return ('- No Data -')
    } else {
      return (
        <span>{data.bank_name} {data.rekening}</span>
      )
    }
  }

  _manipulateState = (props) => {
    let obj = { ...this.state.filter }
    let filter = { ...obj, ...props }
    this.setState({ filter })
  }

  _callback = (event) => {
    if (event) {
      event.preventDefault()
    }
    this.props.getAffiliates(this.state.filter)
  }

  _renderViewAffiliate = (coupon) => {
    return (
      <section className='section'>
        <AdvancedFilter filters={this.filters} callback={(event) => this._callback(event)} manipulateState={(props) => this._manipulateState(props)} />
        <section className='card'>
          <table className='table table-hover table-striped'>
            <thead>
              <tr>
                <th className='text-center'>First Name</th>
                <th className='text-center'>Last Name</th>
                <th className='text-center'>Bank Info</th>
                <th className='text-center'>Status</th>
                <th className='text-center'>Email</th>
                <th className='text-center'>Total Point</th>
                <th className='text-center'>Available Point</th>
                <th className='text-center'>Redemption Details</th>
              </tr>
            </thead>
            <tbody>
              {
                coupon.affiliates.data &&
                coupon.affiliates.data.length > 0
                  ? coupon.affiliates.data.map((item, i) => (
                    <tr key={i}>
                      <td className='text-center'>{item.first_name}</td>
                      <td className='text-center'>{item.last_name}</td>
                      <td className='text-center'>{ this._renderAffiliateData(item.coupon_affiliates) }</td>
                      <td className='text-center'>{ item.user_affiliates.is_request ? 'Transfer Request' : 'No Request' }</td>
                      <td className='text-center'>{item.email}</td>
                      <td className='text-center'>{item.point}</td>
                      <td className='text-center'>{item.available_point}</td>
                      <td className='text-center'>
                        <button className={`btn btn-info ${item.user_affiliates.is_request ? 'boolean-red-badge' : ''}`} data-badge onClick={() => this._selectItem('modal-view-HISTORY', item)}>
                          <i className='fa fa-eye' /> View
                        </button>
                      </td>
                    </tr>
                  ))
                  : <tr>
                    <td className='text-center' colSpan='8'>- No Data -</td>
                  </tr>
              }
            </tbody>
          </table>
        </section>
        <section className='text-center'>
          {
            (coupon.affiliates && coupon.affiliates.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={coupon.affiliates.page || this.state.filter.page}
              itemsCountPerPage={10}
              totalItemsCount={coupon.affiliates.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-view-HISTORY'} onClose={this._toggleModal}>
          <ViewAffiliateHistory detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>
      </section>
    )
  }

  render () {
    const { coupon, preset } = this.props
    return (
      <section>
        <header className='affiliate'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              {
                this.state.tab === 'preset'
                  ? 'Manage Sobat Affiliate Presets'
                  : 'Sobat Affiliate User List'
              }
              {
                (coupon.fetching || coupon.processing) &&
                <div className='badge badge-info ml-2'>Loading ...</div>
              }
            </h3>
            <div className='btn-group'>
              <button className={`btn btn-primary ${this.state.tab === 'affiliates-list' && 'active'}`} onClick={() => this._changeTab('affiliates-list')}>User List</button>
              <button className={`btn btn-primary ${this.state.tab === 'preset' && 'active'}`} onClick={() => this._changeTab('preset')}>Presets</button>
            </div>
          </div>
        </header>
        <section>
          { this.state.tab === 'affiliates-list' && this._renderViewAffiliate(coupon) }
          { this.state.tab === 'preset' && this._renderAffiliatePreset(preset) }
        </section>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  preset: state.preset,
  coupon: state.coupon
})

const dispatchToProps = (dispatch) => ({
  getPreset: () => dispatch(PresetActions.presetOrderRequest()),
  getAffiliates: (filter) => dispatch(CouponActions.getAffiliatesRequest(filter)),
  putPreset: (data) => dispatch(PresetActions.presetOrderUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(Affiliate)



// WEBPACK FOOTER //
// ./src/Pages/Coupon/ManageAffiliate.js